import { CellMediaThumb } from '@uderly/react-uderly-ui';
export default CellMediaThumb;

// import React, { useEffect, useState } from "react";
// import { CSSProperties, useContext } from "react";

// import { HasMedia, Media } from '@uderly/react-uderly-ui/models';
// import { entityMediaUrl, getImageInfo, ImageInfo } from "@uderly/react-uderly-ui";
// import { ILayoutContext, LayoutContext } from "@uderly/react-uderly-ui";
// // import { LayoutContext, ILayoutContext } from "./LayoutContext";
// import Settings from "../../settings";

// // interface ImageInfo {
// //   exists: boolean;
// //   width?: number;
// //   height?: number;
// //   error?: string;
// //   imageElement?: HTMLImageElement;
// // }

// // const getImageInfo = (imageUrl: string): Promise<ImageInfo> => {
// //   return new Promise((resolve) => {
// //     const img = new Image();

// //     // Optional: Add cross-origin attribute if loading from different domains
// //     img.crossOrigin = "anonymous";

// //     img.onload = () => {
// //       resolve({
// //         exists: true,
// //         width: img.naturalWidth,
// //         height: img.naturalHeight,
// //         imageElement: img
// //       });
// //     };

// //     img.onerror = () => {
// //       resolve({
// //         exists: false,
// //         error: 'Image failed to load'
// //       });
// //     };

// //     // Add a timeout to handle cases where the image request might hang
// //     const timeoutDuration = 5000; // 5 seconds timeout
// //     const timeout = setTimeout(() => {
// //       resolve({
// //         exists: false,
// //         error: 'Request timed out'
// //       });
// //     }, timeoutDuration);

// //     img.src = imageUrl;

// //     // Clean up timeout if image loads or errors out before timeout
// //     img.onload = () => {
// //       clearTimeout(timeout);
// //       resolve({
// //         exists: true,
// //         width: img.naturalWidth,
// //         height: img.naturalHeight,
// //         imageElement: img
// //       });
// //     };

// //     img.onerror = () => {
// //       clearTimeout(timeout);
// //       resolve({
// //         exists: false,
// //         error: 'Image failed to load'
// //       });
// //     };
// //   });
// // };

// interface CellMediaThumbProps {
//   path: string;
//   o: HasMedia;
//   style?: CSSProperties;
//   useFirstImageAsset?: boolean;
//   thumbVersion?: string;
//   defaultVersion?: string;
//   disableExpand?: boolean;
// }

// const CellMediaThumb = ({ path, o, style, useFirstImageAsset, disableExpand, defaultVersion, thumbVersion }: CellMediaThumbProps) => {
//   const layoutContext = useContext(LayoutContext) as ILayoutContext;

//   const [thumbImageInfo, setThumbImageInfo] = useState<ImageInfo | null>(null);

//   const getImageUrl = (m: Media, version: string) => {
//     if (useFirstImageAsset && m)
//       return entityMediaUrl(o.id!, path, m.file_name, version);
//     else
//       return `${Settings.apiUrl}${path}/${o.id}/image/${version}`;
//   }

//   const imageMedia = o.media && o.media.filter((m: Media) =>
//     useFirstImageAsset ? m.mime_type.substring(0, 6) === "image/" : m.collection_name === "image");
//   const thumbImageUrl = !imageMedia ? null : getImageUrl(imageMedia[0], thumbVersion ?? "thumb");

//   const onClickThumbImage = async (m?: Media) => {
//     if (!thumbImageInfo || disableExpand || !m || !imageMedia || imageMedia.length === 0)
//       return;

//     const imageUrl = getImageUrl(m, defaultVersion ?? "default");

//     if (m) {
//       layoutContext.dialog.show({
//         onLoading: async () => {
//           // await delay(2000)
//           if (thumbImageInfo?.exists)
//             layoutContext.dialog.setClassName(
//               `gallery-dialog ${thumbImageInfo.width! > thumbImageInfo.height! ? 'fullscreen-landscape' : 'fullscreen-portrait'}`);
//         },
//         content: <img src={imageUrl} alt={m.file_name} />,
//         className: `gallery-dialog`,
//         title: " "
//       });
//     }
//   }

//   const imageAlt = (imageMedia && imageMedia.length > 0) ? imageMedia[0]!.name : o.id.toString();

//   useEffect(() => {
//     const init = async () => {
//       setThumbImageInfo(await getImageInfo(thumbImageUrl!));
//     }

//     init();
//   }, [thumbImageUrl]);

//   return (
//     <button className="cell-media-thumb" style={style ?? {}}
//       onClick={e => {
//         e.stopPropagation();

//         if (imageMedia && imageMedia.length > 0)
//           onClickThumbImage(imageMedia[0]);
//       }}>

//       {thumbImageUrl && thumbImageInfo?.exists &&
//         <img alt={imageAlt} src={thumbImageUrl} />}
//     </button>
//   );
// }

// export default CellMediaThumb;